<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Pie, mixins } from 'vue-chartjs';

export default {
  name: 'HistoryPieChart',
  extends: Pie, // ✅ This is the correct way to use it in v3.5.0
  mixins: [mixins.reactiveProp],
  props: ['chartData'],
  mounted() {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom'
      }
    });
  }
};
</script>

<style scoped>
canvas {
  max-height: 300px;
}
</style>
